exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SelectedText__selected___1EwSp{font-size:13px;height:100%;display:flex;align-items:center;padding-left:12px}\n", ""]);

// Exports
exports.locals = {
	"selected": "SelectedText__selected___1EwSp"
};